import { Model } from './model';
import { Ship } from './ship';
import { ControlItem } from './control-item';

import { FilterHandler } from '../shared/filter-handler';

import * as moment from 'moment';

export class Tide extends Model {
  id: number;
  code: string;
  status: string;
  start_date: moment.Moment;
  end_date: moment.Moment;
  update_requested: boolean;
  ship: Ship;

  control_items: ControlItem[];

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const tide = new Tide(values);

    tide.control_items = [];

    if (values['controlitems']) {
      for (const item of values['controlitems']) {
        let control_item = new ControlItem();
        control_item = control_item.apiMap(item);
        tide.control_items.push(control_item);
      }
    }
    return tide;
  }
}

export class TideFilter extends FilterHandler {
  code: string;
  ship: Ship[] = [];
  start_date: string;
  end_date: string;
  update_requested: boolean;

  constructor(values: Object = {}) {
    super();

    this.code = '';
    this.ship = [];
    this.start_date = '';
    this.end_date = '';
    this.update_requested = false;

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/tide.ts